import {FieldDescriptor} from "../../common/FormField";
import * as Yup from "yup";
import { validationSchemaVersOre2} from "./Services";
import {useGetDropAttivitaByIdProg, useGetDropNodiByIdProg, useGetDropProgettiByCodDip} from "../../common/Services";
import {Luoghi2List, Minord2List, Opzioni2List,tipoNodoToOpzione} from "./types";
import {UseFormSetValue} from "react-hook-form";



export  type VersOre2Form = Yup.InferType<typeof validationSchemaVersOre2>

export const useFieldsVersOre2_1 = (editOpzione: boolean, isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
  // { name: "id", label: "Id", type: "number", boxSize: "10%" },
  { name: "datareg", label: "Data", type: "date", boxSize: "33%", disabled: isBlocked, },
  { name: "datains", label: "Data Ins.", type: "date", boxSize: "33%", disabled: true },

   {
      name: "opzione",
      label: "Opzione",
      type: "autocomplete",
      boxSize: "33%",
      options:  Opzioni2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: !editOpzione || isBlocked,


    },


]);


export const useFieldsVersOre2_2 = (
  idprog: string,
  setValue: UseFormSetValue<VersOre2Form>,
  setIndclibloc: (v: number) => void,
  isBlocked: boolean
): { fields: FieldDescriptor<VersOre2Form>[]; ready: boolean } => {

  const {data: progetti} = useGetDropProgettiByCodDip();
  const {data: nodi, isSuccess: nodiReady, isFetching: nodiFetching} = useGetDropNodiByIdProg(idprog);
  const {data: attivita, isSuccess: attReady, isFetching: attFetching} = useGetDropAttivitaByIdProg(idprog);

  const fields: FieldDescriptor<VersOre2Form>[] = [
    {
      name: "idprog", label: "Progetto", type: "autocomplete", boxSize: "100%",
      options: () => progetti?.results ?? [],
      optionLabelKey: "desprogblocco", optionValueKey: "idprog",
      disabled: false,
      onChange: (_: any, value: string) => {
        setValue("idnodo", "");
        setValue("idatt", "");
        const p = progetti?.results?.find((p: any) => p.idprog === value);
        setIndclibloc(p?.indclibloc ?? 0);
      }
    },
    {
      name: "idnodo", label: "Nodo", type: "autocomplete", boxSize: "100%",
      options: () => nodi?.results ?? [],
      optionLabelKey: "desnodo", optionValueKey: "idnodo",
      disabled: isBlocked || !idprog,
      onChange: (_: any, value: string) => {
        const n = nodi?.results?.find((n: any) => n.idnodo === value);
        setValue("opzione", tipoNodoToOpzione[n?.tiponodo ?? ""] ?? "", {shouldValidate: true});
      }
    },
    {
      name: "idatt", label: "Attivita", type: "autocomplete", boxSize: "100%",
      options: () => attivita?.results ?? [],
      optionLabelKey: "desatt", optionValueKey: "idatt",
      disabled: isBlocked || !idprog
    }
  ];

  return {
    fields,
    ready: !!idprog && nodiReady && attReady && !nodiFetching && !attFetching
  };
};







export const useFieldsVersOre2_3 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
      { name: "orestraord", label: "Ore Eff.", type: "number", boxSize: "33%",disabled: isBlocked  },

      {
      name: "minstraord",
      label: "Min Eff.",
      type: "autocomplete",
      boxSize: "33%",
      options:  Minord2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: isBlocked,
    },
    { name: "oreord", label: "Ore", type: "number", boxSize: "33%", disabled: true },



]);


export const useFieldsVersOre2_4 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
  { name: "note", label: "Note", type: "textarea", boxSize: "100%", rows: 4, multiline: true, inputProps: { maxLength: 255 }, disabled: isBlocked },
]);

export const useFieldsVersOre2_5 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([

     {
      name: "luogo",
      label: "Luogo",
      type: "autocomplete",
      boxSize: "50%",
      options:  Luoghi2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: isBlocked,
    },


    { name: "km", label: "Km", type: "number", boxSize: "25%", disabled: isBlocked  },
  { name: "trasf", label: "Trasferta", type: "number", boxSize: "25%",disabled: isBlocked },
]);

